/**
 * Email Campaign Analytics Page (Issue #376)
 *
 * Page wrapper for viewing email campaign analytics.
 */

import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { EmailCampaignAnalytics } from './EmailCampaignAnalytics';
import { ArrowLeft } from 'lucide-react';

/**
 * Page for displaying campaign analytics
 */
export const EmailCampaignAnalyticsPage: React.FC = () => {
  const { campaignId } = useParams<{ campaignId: string }>();
  const navigate = useNavigate();

  const parsedCampaignId = campaignId ? parseInt(campaignId, 10) : NaN;

  if (!campaignId || Number.isNaN(parsedCampaignId)) {
    return (
      <div className="max-w-7xl mx-auto p-6">
        <div className="p-6 bg-red-50 border border-red-200 rounded-md text-center">
          <p className="text-red-800">
            {campaignId ? 'Invalid campaign ID' : 'Campaign ID is required'}
          </p>
          <button
            onClick={() => navigate('/fairmanager/campaigns')}
            className="mt-4 px-4 py-2 bg-red-600 text-white rounded-md hover:bg-red-700"
          >
            Back to Campaigns
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto p-6">
      {/* Back button */}
      <button
        onClick={() => navigate('/fairmanager/campaigns')}
        className="flex items-center gap-2 text-gray-600 hover:text-gray-800 mb-6"
      >
        <ArrowLeft className="h-5 w-5" />
        <span>Back to Campaigns</span>
      </button>

      {/* Analytics component */}
      <EmailCampaignAnalytics campaignId={parsedCampaignId} />
    </div>
  );
};

export default EmailCampaignAnalyticsPage;
